export default "__VITE_ASSET__Cm$LiUxC__"